module.exports = __webpack_public_path__ + "media/configurations/ZOC_O-X-X-X-X-O-5fcef318.png";